import * as React from 'react';
import { SVGProps } from 'react';

const IconInComparisonSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M1 1h1v10H1V1zm7.121 4.657-.707-.707 3.536-3.536.707.707L8.12 5.657zM5 6h1v5H5V6zm2 1h1v4H7V7zm3 2H9v2h1V9zM6.707 2.828 6 3.536 7.414 4.95l.707-.707-1.414-1.415zM4 4H3v7h1V4z" />
  </svg>
);
export default IconInComparisonSizeXs;
